export { default as Component } from "./Column.svelte";
export const modes = ["static"];
